import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Checkbox, getRowNumber} from "mindsets-js-sdk";

import Row from './Row';
import {AddChallengeResourceIdsToSelectionAction} from "../../actions/challenge_actions";

export default function () {
    const dispatch = useDispatch();
    const items = useSelector(state => state.challenge_resources);
    const current = useSelector(state => state.challenge_resources_current);
    const limit = useSelector(state => state.challenge_resources_limit);
    const selected_challenge_resource_ids = useSelector(state => state.selected_challenge_resource_ids);
    const selected_challenge_resource_ids_sorted = JSON.parse(JSON.stringify(selected_challenge_resource_ids)).sort();

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">
                        <Checkbox
                            checked={selected_challenge_resource_ids_sorted.join(',') === items.map(item => item.id).sort().join(',')}
                            toggle={() => {
                                let array = [];
                                if (selected_challenge_resource_ids_sorted.join(',') !== items.map(item => item.id).sort().join(',')) {
                                    array = items.map(item => item.id);
                                }
                                dispatch(AddChallengeResourceIdsToSelectionAction(array));
                            }}
                        />
                    </th>
                    <th scope="col">No</th>
                    <th scope="col">ID</th>
                    <th scope="col">Challenge Code</th>
                    <th scope="col">Title</th>
                    <th scope="col">Name</th>
                    <th scope="col">Quiz</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return <Row
                        key={item.id}
                        item={item}
                        row_number={getRowNumber(index, current, limit)}
                    />;
                })}
                </tbody>
            </table>
        </div>
    );
};
